import React, { useRef, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { sendMessage } from '../../reducers/wca/sales-support/sales-support-action';
import { useUtility } from '../../context/UtilityContext';
import { useSocket } from '../../hooks/useSocket';
import { ReactComponent as SendButton } from '../../assets/svgIcons/svgIcons/sendbuttonicon.svg';
import FilesDragAndDrop from '../EnqChat/FilesDragAndDrop';
import { useForm, Controller } from 'react-hook-form';
import { InputTextarea } from 'primereact/inputtextarea';
import data from '@emoji-mart/data';
import Picker from '@emoji-mart/react';
import { ReactComponent as SmileIcon } from '../../svg/smile.svg';
import { ReactComponent as PlusIcon } from '../../svg/plus.svg';
import {
  DOC_INPUT_EXTENTIONS,
  IMAGE_INPUT_EXTENTIONS,
  NO_OF_VIDEOS_AND_IMAGES,
  VIDEO_INPUT_EXTENTIONS,
} from '../../config/FileConstants';
import { API_GET_CONFIG } from '../../api/account.service';
import {
  setIsProductSelected,
  setIsFileSelect,
  changeTicketID,
  updateUserStatus,
  changeIsRecAudioSelect,
  setFiles,
  showFilelimitWarning,
  clearReplyMessage,
  setReplyMessage,
} from '../../reducers/wca/sales-support/sales-support-slice';
import { v4 as uuid } from 'uuid';
import { useLayout } from '../../context/LayoutContext';
import { compressImg } from '../../utils/templateUtils';
import ReplayMessageModal from '../../components/ReplyMessageModal/ReplyMessageModal.js';
import Record from './record';
import { API_GET_IMG_URL, API_UPLOAD_IMG } from '../../api/chat.service';
import QuickNotes from './QuickNotes';

const formatTime = (time) => {
  const minutes = Math.floor(time / 60);
  const seconds = time % 60;

  return `${minutes < 10 ? '0' : ''}${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
};

const Input = () => {
  const [onClickPlusIcon, setOnClickPlusIcon] = useState(false);
  const [openEmoji, setOpenEmoji] = useState(false);
  const [blobURL, setblobUrl] = useState(null);
  const [blobData, setBlobData] = useState(null);
  const [isRecording, setIsRecording] = useState(false);
  const [timer, setTimer] = useState(0);
  const [isDisbaleSend, setIsDisableSend] = useState(false);

  useEffect(() => {
    let intervalId;

    if (isRecording) {
      intervalId = setInterval(() => {
        setTimer((prevTimer) => prevTimer + 1);
      }, 1000);
    } else {
      clearInterval(intervalId);
      setTimer(0);
    }

    return () => {
      clearInterval(intervalId);
    };
  }, [isRecording]);

  const textAreaRef = useRef(null);
  const divPlusIconRef = useRef();
  const divFileAndPhotoRef = useRef();
  const dispatch = useDispatch();
  const { toast } = useLayout(null);

  const { selectedMetadataId } = useUtility();
  const { chatId, user, isRecAudioSelect, forwardMessagesFlag, messageForReply, replyMessage } =
    useSelector((state) => state.wcaEnqChats);
  // const { socket } = useSocket(selectedMetadataId, `chats-${selectedMetadataId}`);

  const defaultValues = { content: '' };
  const { control, reset, handleSubmit, setValue, getValues } = useForm({ defaultValues });

  // const [enterIsSend] = useState(false);
  const [enterIsSend, setEnterIsSend] = useState(false);

  const onSubmit = (data) => {
    handleSend(data.content);
  };

  // ✅ Send message
  const handleSend = () => {
    const message = getValues('content');
    if (!message?.trim()) return;

    const payload = {
      messaging_product: 'whatsapp',
      recipient_type: 'individual',
      to: user?.phone,
      type: 'text',
      text: {
        body: message.trim(),
      },
      ...(replyMessage && {
        context: {
          message_id: messageForReply?.msgId,
        },
      }),
    };
    // if (socket) {
    //   socket.emit('send_message', {
    //     metadataid: selectedMetadataId,
    //     ...payload,
    //   });
    // }
    try {
      dispatch(sendMessage({ metadataid: selectedMetadataId, data: payload }));
    } catch (error) {
      toast.current.show({
        severity: 'error',
        detail: error.response.data.message,
      });
    }

    reset();
    dispatch(clearReplyMessage({}));
    setOpenEmoji(false);
  };

  // ✅ Join room
  // useEffect(() => {
  //   if (!socket) return;
  //   socket.emit('join_room', { metadataid: selectedMetadataId, phone: user?.phone });
  //   return () => socket.off('join_room');
  // }, [socket, selectedMetadataId, user?.phone]);

  // ✅ Listen for messages
  // useEffect(() => {
  //   if (!socket) return;

  //   const onReceive = (msg) => {
  //     dispatch({ type: 'RECEIVE_SOCKET_MESSAGE', payload: msg });
  //   };

  //   socket.on('receive_message', onReceive);
  //   return () => socket.off('receive_message', onReceive);
  // }, [socket, dispatch]);

  // ✅ Emoji insert support
  const handleEmojiSelect = (emoji) => {
    const native = emoji?.native;
    const input = textAreaRef.current;
    const value = getValues('content') || '';

    const start = input?.selectionStart ?? value.length;
    const end = input?.selectionEnd ?? value.length;

    const newValue = value.substring(0, start) + native + value.substring(end);

    setValue('content', newValue, { shouldDirty: true, shouldTouch: true });

    setTimeout(() => {
      input?.setSelectionRange(start + native.length, start + native.length);
      input?.focus();
    }, 0);

    setOpenEmoji(true);
  };

  function OptionsComponenet() {
    return (
      <div
        ref={divFileAndPhotoRef}
        className="flex __br justify-content-center align-items-center __sendOptionsAfter "
      >
        <div className="flex  flex-column justify-content-center align-items-center ">
          <div className="__itemDiv">
            <input
              type="file"
              style={{ display: 'none' }}
              id="video"
              onChange={(e) => handleUpload(e.target, 'media')}
              accept={`${IMAGE_INPUT_EXTENTIONS} ,${VIDEO_INPUT_EXTENTIONS}`}
              multiple
            />

            <label htmlFor="video" className="cursor-pointer flex align-items-center gap-1">
              <i className="pi pi-paperclip" />
              <span>Photos & Videos</span>
            </label>
          </div>
          <div className="__itemDiv">
            <label
              onClick={handelProdSend}
              className="cursor-pointer flex align-items-center gap-1"
            >
              <i className="pi pi-qrcode" />
              <span>Products</span>
            </label>
          </div>

          <div className="__itemDiv">
            <input
              type="file"
              style={{ display: 'none' }}
              id="Documents"
              onChange={(e) => handleUpload(e.target, 'doc')}
              multiple
              accept={`${DOC_INPUT_EXTENTIONS}`}
            />
            <label htmlFor="Documents" className="cursor-pointer flex align-items-center gap-1">
              <i className="pi pi-file" />
              <span>Documents</span>
            </label>
          </div>
        </div>
      </div>
    );
  }

  const handleClickOutside = (event) => {
    if (
      divFileAndPhotoRef.current &&
      !divFileAndPhotoRef.current.contains(event.target) &&
      divPlusIconRef.current &&
      !divPlusIconRef.current.contains(event.target)
    ) {
      if (!onClickPlusIcon) {
        setOnClickPlusIcon(false);
      }
    }
  };

  useEffect(() => {
    // Fetch API data
    const fetchConfig = async () => {
      try {
        const response = await API_GET_CONFIG();
        if (response && response.enterIsSend !== undefined) {
          setEnterIsSend(response.enterIsSend);
        }
      } catch (error) {
        console.error('Error fetching config:', error);
      }
    };
    document.addEventListener('click', handleClickOutside);
    fetchConfig();
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  const handleUpload = async (e, type) => {
    let fileArray = Array.from(e.files).slice(0, 5);
    let files = [];
    var limit = 0;
    if (e.files.length > NO_OF_VIDEOS_AND_IMAGES) {
      dispatch(
        showFilelimitWarning({
          filesLength: e.files.length,
          filesLengthWarning: true,
        }),
      );
    }
    for (const x of fileArray) {
      const unique_id = uuid();
      limit++;
      if (limit > NO_OF_VIDEOS_AND_IMAGES) {
        break;
      }

      try {
        // Attempt to read the file
        await new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = () => resolve();
          reader.onerror = () => reject(new Error('File read error'));
          reader.readAsArrayBuffer(x);
        });
        if (type === 'media') {
          if (x?.type == 'image/png' || x?.type == 'image/jpeg' || x?.type == 'image/jpg') {
            const compressedFile = await compressImg(x);
            let data = new File([compressedFile], compressedFile.name, {
              type: compressedFile.type,
            });
            files = [
              ...files,
              {
                id: unique_id.slice(0, 8),
                data,
                type: 'image',
              },
            ];
          } else if (x?.type == 'video/mp4' || x?.type == 'video/mp3') {
            files = [
              ...files,
              {
                id: unique_id.slice(0, 8),
                data: x,
                type: 'video',
              },
            ];
          }
        } else if (type === 'doc') {
          files = [
            ...files,
            {
              id: unique_id.slice(0, 8),
              data: x,
              type: 'document',
            },
          ];
        } else {
          if (x?.type == 'image/png' || x?.type == 'image/jpeg' || x?.type == 'image/jpg') {
            const compressedFile = await compressImg(x);
            let data = new File([compressedFile], compressedFile.name, {
              type: compressedFile.type,
            });
            files = [
              ...files,
              {
                id: unique_id.slice(0, 8),
                data,
                type: 'image',
              },
            ];
          } else if (x?.type == 'video/mp4' || x?.type == 'video/mp3') {
            files = [
              ...files,
              {
                id: unique_id.slice(0, 8),
                data: x,
                type: 'video',
              },
            ];
          } else {
            files = [
              ...files,
              {
                id: unique_id.slice(0, 8),
                data: x,
                type: 'document',
              },
            ];
          }
        }
      } catch (error) {
        toast.current.show({
          severity: 'error',
          detail: `Error processing file: ${x.name}.`,
        });
        files = [
          ...files,
          {
            id: unique_id.slice(0, 8),
            data: x,
            type: 'document',
          },
        ];
      }
    }
    dispatch(setFiles(files));
    dispatch(setIsFileSelect(true));
  };

  const handelProdSend = () => {
    dispatch(setIsProductSelected(true));
  };
  const hideReplyHandler = () => {
    dispatch(setReplyMessage({ replyMessage: false }));
  };

  const handelAudioSend = async () => {
    setIsDisableSend(true);
    let name = Math.floor(Math.random() * 10000000) + '.mpeg';
    var file = new File([blobData], `${name}`, { type: 'audio/mpeg' });
    try {
      if (blobData) {
        let payload = {
          messaging_product: 'whatsapp',
          recipient_type: 'individual',
          to: user?.phone,
          audio: {
            voice: true,
          },
          ...(replyMessage && {
            context: {
              message_id: messageForReply?.msgId,
            },
          }),
        };
        const respUrl = await API_GET_IMG_URL(user);

        const UploadUrl = respUrl.data.src;
        if (UploadUrl) {
          await API_UPLOAD_IMG(UploadUrl, file, 'audio/mpeg');

          payload.type = 'audio';
          payload.audio.link = respUrl.data.url;
        }

        console.log('payload', payload);

        dispatch(sendMessage({ metadataid: selectedMetadataId, data: payload }))
          .unwrap()
          .then(() => {
            reset();
            setblobUrl(null);
            setBlobData(null);
            dispatch(changeIsRecAudioSelect(false));
            setIsDisableSend(false);
            dispatch(clearReplyMessage({}));
          });

        // !closedTicketStatus
        //   ? await API_SEND_MSG(user?.ticketId, data).then(() => {
        //       reset();
        //       setblobUrl(null);
        //       setBlobData(null);
        //       dispatch(changeIsRecAudioSelect(false));
        //       setIsDisableSend(false);
        //       dispatch(clearReplyMessage({}));
        //     })
        //   : await API_START_CHAT(data).then((e) => {
        //       dispatch(changeTicketID(e.data.id));
        //       dispatch(updateUserStatus({ ticketStatus: e.data.ticketStatus }));
        //       dispatch(changeIsRecAudioSelect(false));
        //       reset();
        //       setblobUrl(null);
        //       setBlobData(null);
        //       setIsDisableSend(false);
        //       dispatch(clearReplyMessage({}));
        //     });
      }
    } catch (error) {
      toast.current.show({
        severity: 'error',
        detail: error?.response?.message,
      });
    }
  };

  const handleRecAudioSend = () => {
    if (blobURL !== null) {
      handelAudioSend();
    }
  };
  const handlePaste = (e) => {
    if (e.clipboardData.files.length) {
      handleUpload(e.clipboardData);
    }
  };
  const handleQuickNoteClick = (qnote) => {
    setValue('content', qnote);
  };
  return (
    <div className="flex w-full flex-column __inputContainer" style={{ background: '#f8f8fc' }}>
      {onClickPlusIcon && <OptionsComponenet />}

      {replyMessage && (
        <div className=" px-3  py-2 w-full flex justify-content-between align-items-center gap-3 replyContainer ">
          <div className="w-full replyInnerContainer px-2">
            <ReplayMessageModal message={messageForReply} key_id={messageForReply?.message.gsId} />
          </div>
          <div onClick={hideReplyHandler}>
            <i className="pi pi-times" style={{ fontSize: '1.15rem' }}></i>
          </div>
        </div>
      )}
      <div className="flex flex-column w-full md:flex-row align-items-end  py-2 px-3`">
        <div className="flex w-full md:w-auto justify-content-between gap-3 relative">
          {openEmoji && (
            <div className="absolute border-1" style={{ bottom: 90, zIndex: 3 }}>
              <Picker
                data={data}
                onEmojiSelect={handleEmojiSelect}
                onClickOutside={() => setOpenEmoji(false)}
              />
            </div>
          )}

          {/* Emoji + Attach buttons */}
          <div className="flex __EmojiItems gap-1 mr-2">
            <div
              className="__mb"
              onClick={(e) => {
                e.stopPropagation();
                setOpenEmoji((prev) => !prev);
              }}
            >
              <span className="__Items p-2">
                <SmileIcon />
              </span>
            </div>

            <div
              ref={divPlusIconRef}
              className={`cursor-pointer p-2 ${!onClickPlusIcon ? '' : '__backC'}`}
              onClick={() => setOnClickPlusIcon(!onClickPlusIcon)}
            >
              <div className={`${!onClickPlusIcon ? '__ItemsAdd' : '__ItemsCancel'}`}>
                <PlusIcon />
              </div>
            </div>
          </div>
        </div>

        {/* Input form */}
        <form className="w-full md:w-9 relative" onSubmit={handleSubmit(handleSend)}>
          <FilesDragAndDrop onUpload={() => {}}>
            <div className="inputBox relative w-full">
              <Controller
                name="content"
                control={control}
                render={({ field }) => (
                  <InputTextarea
                    onPaste={handlePaste}
                    id={field.content}
                    {...field}
                    ref={textAreaRef}
                    className="w-full h-auto"
                    rows={3}
                    cols={30}
                    autoResize
                    placeholder={!isRecording && !blobURL ? 'Enter your message...' : ''}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter' && enterIsSend) {
                        e.preventDefault();
                        handleSend(field.value);
                      }
                    }}
                  />
                )}
              />

              <div
                className={`absolute sendbutton flex justify-content-center align-items-center `}
                style={{ bottom: '10px', right: '5px' }}
              >
                {blobData && (
                  <div className="flex">
                    <audio
                      src={blobURL}
                      id="audioElement"
                      className=""
                      style={{ width: '225px' }}
                      controls
                    ></audio>
                    {!isDisbaleSend && (
                      <button
                        icon="pi pi-trash"
                        className="mx-1 __delBtn  "
                        onClick={() => {
                          dispatch(changeIsRecAudioSelect(false));
                          setBlobData(null);
                          setblobUrl(null);
                        }}
                      >
                        <i class="pi pi-trash"></i>
                      </button>
                    )}
                  </div>
                )}

                {isRecording ? (
                  <div className="mr-1 __audioGif flex justify-content-center align-items-center">
                    <div className="mr-1">
                      <img src="./assets/Audio.gif" />
                      <img src="./assets/Audio.gif" />
                      <img src="./assets/Audio.gif" />
                      <img src="./assets/Audio.gif" />
                    </div>

                    <div>
                      <span>{formatTime(timer)}</span>
                    </div>
                  </div>
                ) : (
                  <button
                    type={blobURL != null ? '' : 'submit'}
                    onClick={handleRecAudioSend}
                    disabled={isDisbaleSend}
                  >
                    {isDisbaleSend ? (
                      <i
                        class="pi pi-spin pi-spinner"
                        style={{ color: 'black', width: '1.5rem' }}
                      ></i>
                    ) : (
                      <SendButton />
                    )}
                  </button>
                )}
              </div>
            </div>
          </FilesDragAndDrop>
        </form>
        <div className="w-2 min-w-min mb-1 hidden md:flex align-items-center  ml-2">
          <div>
            <Record
              setblobUrl={setblobUrl}
              setBlobData={setBlobData}
              isRecording={isRecording}
              setIsRecording={setIsRecording}
            />
          </div>
          <QuickNotes handleClick={handleQuickNoteClick} />
        </div>
      </div>
    </div>
  );
};

export default Input;
